var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatxpbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 55,
    viewBox: "0 0 45 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.423 25.0344C44.423 38.6571 35.0115 51.3962 22.3648 54.489C9.71814 51.3962 0.306641 38.6571 0.306641 25.0344V10.3071L22.3648 0.488953L44.423 10.3071V25.0344ZM22.3648 49.5799C31.5558 47.1253 39.5212 36.178 39.5212 25.5744V13.498L22.3648 5.83986L5.20846 13.498V25.5744C5.20846 36.178 13.1739 47.1253 22.3648 49.5799ZM29.8401 37.3071L22.2913 32.7662L14.767 37.3071L16.7523 28.7162L10.1103 22.9726L18.8846 22.2117L22.2913 14.1117L25.7226 22.1871L34.4969 22.948L27.8304 28.7162L29.8401 37.3071Z",
    fill: "#0056D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatxpbadge);
export default __webpack_public_path__ + "static/media/statxpbadge.1c2488ea38521053f10291bd87822163.svg";
export { ForwardRef as ReactComponent };